import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import PostMachineryRequirement from '.';

interface IPostMachineryRequirementProps {
  onSuccess?: (response: IAddedAdvertisementResponse) => void;
}

const usePostMachineryRequirement = ({
  onSuccess,
}: IPostMachineryRequirementProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IMachineryRequirementPayload) => {
      return PostMachineryRequirement(payload);
    },
    onSuccess: data => {
      onSuccess && onSuccess(data);
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export {usePostMachineryRequirement};
